import styled from "styled-components";

export const PageContentSections = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3rem;
`;
